import { gql } from '@apollo/client';

export const GET_REGISTER_FORM_CONFIG_GQL = gql`
    query getInternshipSettings {
        internshipSettings {
            settings {
                interestDirectionIsRequired
                emailIsRequired
                phoneIsRequired
                telegramNickNameIsRequired
                cityIsRequired
                educationIsRequired
                descriptionYourSelfIsRequired
                whatYouWantToKnowAboutInternshipIsRequired
                startEducationYears
                finishEducationYears
                start
                finish
                firstNameIsRequired
                lastNameIsRequired
                isOpened
                hoursPerWeekIsRequired
                englishLevelIsRequired
                studyTypeIsRequired
                howDidYouKnowIsRequired
                refIdIsRequired
            }
        }
    }
`;

export default GET_REGISTER_FORM_CONFIG_GQL;
